import { Chip, ChipProps } from "@mui/material";
import * as React from "react";
import { FileStatus } from "../../../../Core/Api/Types/file-status";

import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import CloudOffOutlinedIcon from "@mui/icons-material/CloudOffOutlined";
import CloudDoneOutlinedIcon from "@mui/icons-material/CloudDoneOutlined";
import RadioButtonCheckedOutlinedIcon from "@mui/icons-material/RadioButtonCheckedOutlined";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";

export interface FileStatusChipProps extends ChipProps {
  status: FileStatus;
}

const FileStatusChip: React.FC<FileStatusChipProps> = (props) => {
  const { status, ...otherProps } = props;

  let _icon = <></>;
  let _label = "";
  let _color: ChipProps["color"] = "default";
  switch (status) {
    case FileStatus.Broken:
      _icon = <BuildCircleOutlinedIcon />;
      _label = "Broken";
      _color = "warning";
      break;
    case FileStatus.Deleted:
      _icon = <DeleteForeverOutlinedIcon />;
      _label = "Deleted";
      _color = "info";
      break;
    case FileStatus.Offline:
      _icon = <CloudOffOutlinedIcon />;
      _label = "Offline";
      _color = "warning";
      break;
    case FileStatus.Online:
      _icon = <CloudDoneOutlinedIcon />;
      _label = "Online";
      _color = "success";
      break;
    case FileStatus.Recording:
      _icon = <RadioButtonCheckedOutlinedIcon />;
      _label = "Recording";
      _color = "primary";
      break;
  }
  return <Chip icon={_icon} label={_label} color={_color} size={"small"} {...otherProps} />;
};

export default FileStatusChip;
